<template>
  <section>
    <!--工具条-->
    <RunCenterDiagramToolbar :buttonList="buttonList" @callFunction="callFunction"></RunCenterDiagramToolbar>
    <el-col>
      <div id="up" style="margin-bottom:80px;">
        <div class="siteLine_right">
          <img src="/static/images/right.png" class="right_icon" />
          <div class="ystep-progress-bar"></div>
          <ul>
            <li v-for='item in upSiteDataList' :key="item.SiteNumber">
              <div :id="setId('up_colour_',item.SiteNumber)" class="white"></div>
              <img :id="setId('up_img_',item.SiteNumber)" class="no_car"/>
              <div :id="setId('up_licensePlate_',item.SiteNumber)" class="licensePlate"></div>
              <div class="site">{{ item.SiteChineseName }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div id="down" v-if="downSiteDataList.length > 0">
        <div class="siteLine_left">
          <img src="/static/images/left.png" class="left_icon" />
          <div class="ystep-progress-bar"></div>
          <ul>
            <li v-for='item in downSiteDataList' :key="item.SiteNumber">
              <div :id="setId('down_colour_',item.SiteNumber)" class="white"></div>
              <div :id="setId('down_licensePlate_',item.SiteNumber)" class="licensePlate"></div>
              <img :id="setId('down_img_',item.SiteNumber)" class="no_car"/>
              <div class="site">{{ item.SiteChineseName }}</div>
            </li>
          </ul>
        </div>
      </div>
    </el-col>
  </section>
</template>

<script>
import { getBusLinesListPage, getSiteDataByBusLinesId,getAllVehiclesData,getLastTerminalsInfoData } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import RunCenterDiagramToolbar from "../../components/QueryToolbar/RunCenterDiagramToolbar";
import webSocket from '../../web_socket.js';
import pako from '../../pako.min.js';
import gcoord  from '../../gcoord.js';
import { gcoord_transform } from '../../coordinate.js';
import { getVehiclesSpeed,getLastTimeData,getSocketCoordinateDistanceData,getVehiclesTravelPosition,
 getVehiclesTravelPositionByLastTimeData,vehiclesIconAdd,updateSiteLineBackgroundColor,removeClassName,
 licensePlateAdd,storageVehiclesRunningData,getVehiclesRunningData } from '../../baseCommon.js';
import { connectSocketServer } from '../../socketServer.js';

export default {
  components: { RunCenterDiagramToolbar },
  data() {
    return {
      filters: {
        busLinesId: ""
      },
      buttonList: [],
      allVehicles: [],
      filterVehicles: [],
      busLineUpDirectionName:'',
      busLineDownDirectionName:'',
      upSiteDataList: [],
      downSiteDataList: []
    };
  },
  methods: {
    callFunction(busLinesId) {
      this.filters = {
        busLinesId: busLinesId
      };
      this.getSiteData();
      this.updateFilterVehicles();   
    },
    getBusLines(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.filters.busLinesId = res.data.response.data.length > 0?res.data.response.data[0].Id:"";
        this.getSiteData();
        this.updateFilterVehicles();
      });
    },
    getSiteData(){
      this.initClass();
      let para = {
        busLinesId: this.filters.busLinesId
      };
      getSiteDataByBusLinesId(para).then(res => {
        this.busLineUpDirectionName='';
        this.busLineDownDirectionName='';
        this.upSiteDataList= [];
        this.downSiteDataList= [];
        if(res.data.SiteDatas.length > 0){
          if(res.data.BusLineUpDirectionChineseName !== null){
            this.busLineUpDirectionName = res.data.BusLineUpDirectionChineseName;
            this.upSiteDataList = res.data.SiteDatas.filter(it=> it.BusLineDirectionChineseName === res.data.BusLineUpDirectionChineseName);
          }
          if(res.data.BusLineDownDirectionChineseName !== null){
            this.busLineDownDirectionName = res.data.BusLineDownDirectionChineseName;
            this.downSiteDataList = res.data.SiteDatas.filter(it=> it.BusLineDirectionChineseName === res.data.BusLineDownDirectionChineseName);
            this.downSiteDataList = this.downSiteDataList.sort(this.compareDesc("SiteNumber"));
          }
        }
      });
    },
    compareDesc(property){
      return function(a,b){
        let value1 = a[property];
        let value2 = b[property];
        return value2 - value1;
      }
    },
    setId(type,siteNumber){
      return type + "site_" + siteNumber;
    },
    getVehicles(){
      let para = {
      }; 
      getAllVehiclesData(para).then(res => {
        this.allVehicles = res.data.data;
      });
    },
    updateFilterVehicles(){
      this.filterVehicles = this.allVehicles.filter(item => item.BusLinesId === this.filters.busLinesId);
      this.getLastTerminalsInfo();
    },
    initClass(){
      this.upSiteDataList.forEach(upItem => {
        document.getElementById("up_colour_site_"+upItem.SiteNumber).setAttribute("class","white");
        document.getElementById("up_img_site_"+upItem.SiteNumber).setAttribute("class","no_car");
        document.getElementById("up_licensePlate_site_"+upItem.SiteNumber).setAttribute("class","licensePlate");
        document.getElementById("up_licensePlate_site_"+upItem.SiteNumber).innerHTML="";
      });

      this.downSiteDataList.forEach(downItem => {
        document.getElementById("down_colour_site_"+downItem.SiteNumber).setAttribute("class","white");
        document.getElementById("down_licensePlate_site_"+downItem.SiteNumber).setAttribute("class","licensePlate");
        document.getElementById("down_licensePlate_site_"+downItem.SiteNumber).innerHTML="";
        document.getElementById("down_img_site_"+downItem.SiteNumber).setAttribute("class","no_car");
      });
    },
    getLastTerminalsInfo(){
      let companyId=0;
      let terminalsIds='';
      if(this.filterVehicles.length > 0) {
        for (let i = 0; i < this.filterVehicles.length; i++) {
          if(i === 0){
            companyId = this.filterVehicles[i].CompanyId; 
            terminalsIds = this.filterVehicles[i].TerminalsId; 
          } else {
            terminalsIds+=','+this.filterVehicles[i].TerminalsId;
          }
        }
      }
  
      let para = {
        CompanyId:companyId,
        TerminalsIds:terminalsIds
      }; 
      getLastTerminalsInfoData(para).then(res => {
        if(res.data.response.dataCount > 0){
          let currentTime =new Date();
          res.data.response.data.forEach(element => {
            let lastLocationTime = new Date(Date.parse(element.LOCATION_TIME));
            lastLocationTime = new Date(lastLocationTime.setMinutes(lastLocationTime.getMinutes() + 15)); //最后定位时间添加15分钟
            if(currentTime < lastLocationTime){
              let BD09 = gcoord_transform("WGS84","BD09",element.LONGITUDE,element.LATITUDE); //转百度坐标经纬度
              this.getSocketData(1,element.SIM_ID,BD09[0],BD09[1],element.LOCATION_TIME,element.DIRECTION,element.SPEED_SATELLITE,element.SPEED_SENSOR,null);
            }
          });
        }
      });
    },
    // type: 1表示获取的是数据库数据  2表示获取的是 socket 数据
    getSocketData(formType, simId,longitude,latitude,locationTime,direction,speedSatellite,speedSensor,data){
      let speed = Math.max(speedSatellite,speedSensor);
      let lineSiteViewVehiclesFilterData = this.filterVehicles.filter(item => item.SimId === simId);
      if(lineSiteViewVehiclesFilterData.length>0){ 
        let lowPeakPeriodSpeed = lineSiteViewVehiclesFilterData[0].LowPeakPeriodSpeed;
        let fastigiumSpeed = lineSiteViewVehiclesFilterData[0].FastigiumSpeed;
        let morningFastigiumTimeSlot = lineSiteViewVehiclesFilterData[0].MorningFastigiumTimeSlot;
        let nightFastigiumTimeSlot = lineSiteViewVehiclesFilterData[0].NightFastigiumTimeSlot;
        let licensePlateNumber = lineSiteViewVehiclesFilterData[0].LicensePlateNumber;
        speed = getVehiclesSpeed(speed,lowPeakPeriodSpeed,fastigiumSpeed,morningFastigiumTimeSlot,nightFastigiumTimeSlot);
        // storageLastTimeSpeed(simId,locationTime,speed);

        removeClassName('carClassName',simId,'singleVehiclesIconRemove');
        removeClassName('licensePlateClassName',simId,'singleLicensePlateRemove');
        removeClassName('groundColorClassName',simId,'singleBackgroundColorRemove');
        
        if(this.upSiteDataList.length > 0){
          this.vehiclesRunningDiagram("up",this.upSiteDataList,simId,locationTime,speed,latitude,longitude,direction);
        }

        if(this.downSiteDataList.length > 0){
          this.vehiclesRunningDiagram("down",this.downSiteDataList,simId,locationTime,speed,latitude,longitude,direction);
        }

        let upVehiclesRunningData = getVehiclesRunningData('up',simId);
        let downVehiclesRunningData = getVehiclesRunningData('down',simId);
        let siteNumber = 0;
        let lastSiteNumber = 0;

        let upSiteNumber = 0;
        let upLastSiteNumber = 0;
        let upNextSiteDistance = 0;
        let upLastNextSiteDistance = 0;

        let downSiteNumber = 0;
        let downLastSiteNumber = 0;
        let downNextSiteDistance = 0;
        let downLastNextSiteDistance = 0;

        let isContinue = true;
        let type = "up";

        if(upVehiclesRunningData.length > 0){
          upSiteNumber = upVehiclesRunningData[0].siteNumber;
          upLastSiteNumber = upVehiclesRunningData[0].lastSiteNumber;
          upNextSiteDistance = upVehiclesRunningData[0].nextSiteDistance;
          upLastNextSiteDistance = upVehiclesRunningData[0].lastNextSiteDistance;

          if(parseInt(upSiteNumber) > parseInt(upLastSiteNumber)){
            siteNumber = upSiteNumber;
            lastSiteNumber = upLastSiteNumber;
            isContinue = false;
          }else if(parseInt(upSiteNumber) === parseInt(upLastSiteNumber)){
            if(parseFloat(upNextSiteDistance) < parseFloat(upLastNextSiteDistance)){
              siteNumber = upSiteNumber;
              lastSiteNumber = upLastSiteNumber;
              isContinue = false;
            }else if(parseFloat(upNextSiteDistance) === parseFloat(upLastNextSiteDistance)){
              siteNumber = upSiteNumber;
              lastSiteNumber = upLastSiteNumber;
              isContinue = true;
            }
          }
        }

        if(isContinue && downVehiclesRunningData.length > 0){
          type = "down";
          downSiteNumber = downVehiclesRunningData[0].siteNumber;
          downLastSiteNumber = downVehiclesRunningData[0].lastSiteNumber;
          downNextSiteDistance = downVehiclesRunningData[0].nextSiteDistance;
          downLastNextSiteDistance = downVehiclesRunningData[0].lastNextSiteDistance;

          if(parseInt(downSiteNumber) > parseInt(downLastSiteNumber)){
            siteNumber = downSiteNumber;
            lastSiteNumber = downLastSiteNumber;
          }else if(parseInt(downSiteNumber) === parseInt(downLastSiteNumber)){
            if(parseFloat(downNextSiteDistance) <= parseFloat(downLastNextSiteDistance)){
              siteNumber = downSiteNumber;
              lastSiteNumber = downLastSiteNumber;
            }else{
              type = "up";
            }
          }else{
            type = "up";
          }
        }

        if(siteNumber !== "0"){
          vehiclesIconAdd(type+"_img_site_"+siteNumber,simId);
          licensePlateAdd(type+"_licensePlate_site_"+siteNumber,simId,licensePlateNumber);
        }
        if(lastSiteNumber !== '' && parseInt(lastSiteNumber) < parseInt(siteNumber)){
          updateSiteLineBackgroundColor(simId,type+"_colour_site_"+lastSiteNumber,type+"_img_site_"+lastSiteNumber);
        }
        updateSiteLineBackgroundColor(simId,type+"_colour_site_"+siteNumber,type+"_img_site_"+siteNumber);
     
      }
    },
    vehiclesRunningDiagram(type,siteDataList,simId,locationTime,speed,latitude,longitude,direction){
      let lastTimeData = getLastTimeData(type,simId,locationTime);
      let socketCoordinateDistanceData = getSocketCoordinateDistanceData(siteDataList,simId,locationTime,speed,latitude,longitude,direction);
      let vehiclesTravelPosition = '';
      let lastSiteNumber = 0; //上一次记录的站点默认为0
      let lastNextSiteDistance = 0; //上一次记录的车辆距离下一站距离
      if(lastTimeData === ''){
        vehiclesTravelPosition= getVehiclesTravelPosition(type,simId,locationTime,socketCoordinateDistanceData,direction);
      } else {
        vehiclesTravelPosition= getVehiclesTravelPositionByLastTimeData(type,simId,locationTime,socketCoordinateDistanceData,lastTimeData);
        lastSiteNumber = lastTimeData[0].siteNumber;
        lastNextSiteDistance = lastTimeData[0].nextSiteDistance;
      }
      const vehiclesTravelPositionArr = vehiclesTravelPosition.split(',');
      let siteNumber=vehiclesTravelPositionArr[0]; //车辆坐落站点序号
      let nextSiteDistance =vehiclesTravelPositionArr[1]; //车辆距离下一站距离

      storageVehiclesRunningData(type,simId,siteNumber,lastSiteNumber,nextSiteDistance,lastNextSiteDistance);
      
      // 如果存在上条数据
      //if(lastSiteNumber !== 0 || lastNextSiteDistance !== 0){
        //storageVehiclesRunningData(type,simId,siteNumber,lastSiteNumber,nextSiteDistance,lastNextSiteDistance);
      //}
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLines(pageSizePara);
    this.getVehicles();
    connectSocketServer();
    window.getSocketData = this.getSocketData;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}
</script>

<style lang="css" scoped>
  .siteLine_right{
    width:100%; 
    margin:0 auto; 
    position:relative; 
  }

  .siteLine_right ul {
    height: 200px;
    /*定义flex伸缩盒*/
    display: -webkit-flex;
    /*设置伸缩盒的子元素向两端对齐*/
    justify-content: space-between; 
    position:relative;
    z-index:9; 
    width:91%; 
    left:15px;  
  }

  .siteLine_right ul li {
    font-size: 20px;
    /*固定宽度使文字强制换行竖直排列*/
    width: 20px;
    /* text-align: center; */
    display: -webkit-flex;
    /*设置伸缩盒的子元素向两端对齐*/
    justify-content: space-between;
    /*设置子元素的排列方向是竖直方向*/
    flex-direction: column;
    position:relative; 
  }

  .siteLine_right .white{
    border-radius:50%;
    width:15px;
    height:15px;
    background-color: #ffffff;
    position:absolute; 
    bottom:20px;
  }

  .siteLine_right .red{
    border-radius:50%;
    width:15px;
    height:15px;
    background-color: red; 
    position:absolute;
    bottom:20px;
  }

  .siteLine_right .ystep-progress-bar {
    height: 15px;
    position: absolute;
    z-index:8; 
    bottom:20px;
    background: #4fd27d; 
    display: inline-block; 
    right:30px; 
    left:20px;
    border-radius: 10px;
  }

  .siteLine_right .site{
    width:20px;
    position:absolute;
    bottom:40px;
    font-size:16px;
  }

  .siteLine_right .no_car{
    position: absolute;
    bottom:-15px; 
    left:-7px;
  }

  .siteLine_right .car{
    position: absolute;
    bottom:-15px; 
    left:-7px;
    background: url(/static/images/car_right.png);
    border-radius: 15%;
    width: 30px;
    height: 14px;
  }

  .siteLine_right .licensePlate{
    position: absolute;
    font-size: 6px;
    bottom:0px; 
    left:-11px;
  }

  .right_icon{
    position: absolute;
    z-index:8; 
    bottom:20px; 
    display: inline-block; 
    right:10px;
  }
  
  .siteLine_left{
    width:100%; 
    margin:0 auto; 
    position:relative; 
  }

  .siteLine_left ul {
    height: 200px;
    /*定义flex伸缩盒*/
    display: -webkit-flex;
    /*设置伸缩盒的子元素向两端对齐*/
    justify-content: space-between; 
    position:relative; 
    z-index:9; 
    width:91%; 
    left:20px;  
  }

  .siteLine_left ul li {
    font-size: 20px;
    /*固定宽度使文字强制换行竖直排列*/
    width: 20px;
    /* text-align: center; */
    display: -webkit-flex;
    /*设置伸缩盒的子元素向两端对齐*/
    justify-content: space-between;
    /*设置子元素的排列方向是竖直方向*/
    flex-direction: column;
    position:relative; 
  }

  .siteLine_left .white{
    border-radius:50%;
    width:15px;
    height:15px;
    background-color: #ffffff;
    position:relative; 
    top:15px;
  }

  .siteLine_left .red{
    border-radius:50%;
    width:15px;
    height:15px;
    background-color: red; 
    position:relative;
    top:15px;
  }
  
  .siteLine_left .ystep-progress-bar {
    height: 15px;
    position: absolute;
    z-index:8;
    top:15px;
    display: inline-block;
    background-color: #4fd27d;
    right:20px; 
    left:30px;
    border-radius: 10px;
  }

  .siteLine_left .site{
    width:100%;
    height:170px;
    position:relative;
    top:10px;
    font-size:16px;
  }

  .siteLine_left .no_car{
    position: absolute;
    top:0px; 
    left:-8px;
  }

  .siteLine_left .car{
    position: absolute;
    top:0px; 
    left:-8px;
    background: url(/static/images/car_left.png);
    border-radius: 15%;
    width: 30px;
    height: 14px;
  }

  .siteLine_left .licensePlate{
    position: absolute;
    font-size: 6px;
    top:-17px; 
    left:-15px;
  }

	.left_icon{
    position: absolute;
    z-index:8; 
    top:3px; 
    display: inline-block; 
    left:10px;
  }
</style>
